import React from "react";
import { Button as BootstrapButton } from "react-bootstrap";
import PropTypes from "prop-types";
import Spinner from "../spinner/spinner";

const Button = ({
  children,
  variant = "primary",
  size = "md",
  isLoading = false,
  disabled = false,
  className = "",
  onClick,
  style = {},
  loadingText = "",
  spinnerVariant = "light",
  spinnerSize = "sm",
  withTransition = false,
  isTransitioning = false,
  textSize = "md",
  icon = null,
  iconPosition = "right",
  ...props
}) => {
  const baseStyle = {
    fontWeight: "bold",
    cursor: disabled || isLoading ? "not-allowed" : "pointer",
    opacity: disabled || isLoading ? 0.7 : 1,
    fontSize:
      textSize === "sm" ? "0.875rem" : textSize === "lg" ? "1.25rem" : "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    ...style,
  };

  const transitionClass = withTransition
    ? `transition-transform duration-300 hover:-translate-y-1 ${
        isTransitioning ? "scale-95" : "scale-100"
      }`
    : "";

  return (
    <BootstrapButton
      variant={variant}
      size={size}
      disabled={disabled || isLoading}
      onClick={onClick}
      className={`${className} ${transitionClass}`}
      style={baseStyle}
      {...props}
    >
      {isLoading ? (
        <Spinner
          variant={spinnerVariant}
          size={spinnerSize}
          animation="border"
          layout="row-view"
          label={loadingText}
        />
      ) : (
        <>
          {iconPosition === "left" && icon}
          <span>{children}</span>
          {iconPosition === "right" && icon}
        </>
      )}
    </BootstrapButton>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "link",
    "outline-primary",
    "outline-secondary",
    "outline-success",
    "outline-danger",
    "outline-warning",
    "outline-info",
    "outline-light",
    "outline-dark",
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  textSize: PropTypes.oneOf(["sm", "md", "lg"]),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  loadingText: PropTypes.string,
  spinnerVariant: PropTypes.string,
  spinnerSize: PropTypes.oneOf(["sm", "md", "lg"]),
  withTransition: PropTypes.bool,
  isTransitioning: PropTypes.bool,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(["left", "right"]),
};

Button.defaultProps = {
  variant: "primary",
  size: "md",
  textSize: "md",
  isLoading: false,
  disabled: false,
  className: "",
  style: {},
  loadingText: "",
  spinnerVariant: "light",
  spinnerSize: "sm",
  withTransition: false,
  isTransitioning: false,
  icon: null,
  iconPosition: "right",
};

export default Button;
